<template>
  <section class="rounded-lg border border-slate-200 bg-slate-50 p-3">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h4 class="text-sm font-semibold text-slate-900">链路匹配规则</h4>
        <p class="mt-1 text-xs text-slate-500">维护该客户当月开票链路的指定下游和标签偏好。</p>
      </div>
      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          class="btn-secondary px-3 py-1.5 text-xs"
          v-permission="'enterprise-invoice:plan-customer:manage'"
          :disabled="disabled || !customerId"
          @click="emit('configure-downstream', customer)"
        >
          设置指定下游
        </button>
        <button
          type="button"
          class="btn-secondary px-3 py-1.5 text-xs"
          v-permission="'enterprise-invoice:plan-customer:manage'"
          :disabled="disabled || !customerId"
          @click="emit('configure-tag-preference', customer)"
        >
          设置标签偏好
        </button>
      </div>
    </div>

    <div class="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2">
      <div class="rounded-md bg-white px-3 py-2">
        <div class="text-xs text-slate-500">指定下游</div>
        <div class="mt-1 text-sm font-medium text-slate-900">
          {{ allocationText }}
        </div>
        <div
          v-if="allocationSummary.targetNamesText"
          class="mt-1 truncate text-xs text-slate-600"
          :title="allocationSummary.targetNamesText"
        >
          下游：{{ allocationSummary.targetNamesText }}
        </div>
        <div v-if="allocationSummary.enabledCount > 0" class="mt-1 text-xs text-slate-500">
          剩余自动生成 {{ formatInvoiceAmount(allocationSummary.remainingAmount) }}
        </div>
      </div>
      <div class="rounded-md bg-white px-3 py-2">
        <div class="text-xs text-slate-500">标签偏好</div>
        <div class="mt-1 text-sm font-medium text-slate-900">
          {{ preferenceText }}
        </div>
        <div v-if="preferenceSummary.hiddenCount > 0" class="mt-1 text-xs text-slate-500">
          另有 {{ preferenceSummary.hiddenCount }} 个偏好标签
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { downstreamAllocationSummary, downstreamPreferenceSummary } from '../downstreamRules.mjs'
import { formatInvoiceAmount } from '../utils'

const props = defineProps({
  customer: { type: Object, default: null },
  downstreamAllocations: { type: Array, default: () => [] },
  downstreamTagPreferences: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['configure-downstream', 'configure-tag-preference'])

const customerId = computed(() => props.customer?.id || props.customer?.planCustomerId || null)
const customer = computed(() => props.customer ? {
  ...props.customer,
  id: customerId.value
} : null)
const allocationSummary = computed(() => downstreamAllocationSummary(props.downstreamAllocations, customer.value))
const preferenceSummary = computed(() => downstreamPreferenceSummary(props.downstreamTagPreferences, customerId.value))

const allocationText = computed(() => {
  if (!customerId.value) return '客户加入本月后可设置'
  if (allocationSummary.value.enabledCount === 0) return '未指定下游'
  return `已指定 ${allocationSummary.value.enabledCount} 个下游，合计 ${formatInvoiceAmount(allocationSummary.value.totalAmount)}`
})

const preferenceText = computed(() => {
  if (!customerId.value) return '客户加入本月后可设置'
  if (preferenceSummary.value.enabledCount === 0) return '未设置标签偏好'
  return preferenceSummary.value.shortText
})
</script>
